'use client'
import { convertDate, getImgURL } from '@/shared/utils'
import React, { useEffect, useState } from 'react'
import CommonContent from '../../commonContent/inedex'
import InnerHTML from '../../InnerHtml'
import MyImage from '../../myImage'
import PitchPlaceholder from '@/assets/images/placeholder/pitch.svg'
import Cup from '@/assets/images/placeholder/cup.svg'
import Stadium from '@/assets/images/placeholder/stadium.png'
import useTimer from '@/shared/hooks/useTimer'
import { RightArrow, VerifyIcon } from '@/shared/Icons'
import { useLazyQuery } from '@apollo/client'
import { MATCH_DETAIL } from '@/graphql/match/match.query'
import usePolling from '@/shared/hooks/usePolling'
import CustomLink from '../../customLink'

function MatchInfo({ data }: any) {
  const [scoreData, setScoreData] = useState<any>()
  const Timer = ({ timer }: { timer: any }) => {
    if (timer.hours !== 0 && timer.min !== 0) {
      return (
        <div>
          {timer.days}D : {timer.hours}H : {timer.min}M : {timer.sec}S
        </div>
      )
    } else {
      return null
    }
  }
  useEffect(() => {
    getMatchData()
  }, [])

  const [getMatchData] = useLazyQuery(MATCH_DETAIL, {
    fetchPolicy: 'no-cache',
    variables: { input: { _id: data?.oMatch?._id } },
    onCompleted: (data: any) => {
       setScoreData(data?.getMatchById)
    }
  })

  usePolling(() => getMatchData(), {
    deps: [data?.oMatch?._id],
    interval: 5000,
    skip: data?.oMatch?.sStatusStr === 'completed' || data?.oMatch?.sStatusStr === 'cancelled'
  })

  const handleClick = (sSlug: string) => {
    sSlug = sSlug?.replace('cricket/live-score', 'live-cricket-score')
    if (data?.oMatch?.sStatusStr === 'live') return `/${sSlug}`
    else if (data?.oMatch?.sStatusStr === 'scheduled') return `/${sSlug}`
    else if (data?.oMatch?.sStatusStr === 'completed' || data?.oMatch?.sStatusStr === 'cancelled') return `/${sSlug}`
    return ''
  }

  return (
    <>
      {/* info */}
      <div className='flex items-center justify-between pb-4 md:pb-[30px] border-b border-borderStroke gap-4'>
        <div>
          <span className='text-textDselected font-normal mb-1 md:mb-2 text-xs md:text-base'>{scoreData?.sSubtitle}</span>
          <CustomLink href={handleClick(scoreData?.oSeo?.sSlug)}>
            <div className='text-sm dark:text-ScheduledBG text-primary-500 md:text-lg font-bold flex gap-1 items-center'>
              {data?.oMatch?.sTitle}
              <span className='w-3 h-3 md:w-4 md:h-4'>
                <RightArrow />
              </span>{' '}
            </div>
          </CustomLink>
        </div>
        {scoreData?.oSeries?.oCategory?.oImg?.sUrl && (
          <MyImage
            className='w-[46px] h-[54px] object-cover md:w-[60px] md:h-[68px] rounded-lg'
            src={getImgURL(scoreData?.oSeries?.oCategory?.oImg?.sUrl)}
            height={46}
            width={46}
            alt='Team'
          />
        )}
      </div>

      <div className='grid grid-cols-12 text-center py-4 md:py-6 w-full border-b border-borderStroke'>
        <div className='col-span-12 lg:col-span-8 text-left'>
          <div className='grid  grid-cols-12 pb-4 md:pb-0 border-b border-borderStroke md:border-b-0'>
            <div className='col-span-3'>
              <span className='flex items-center mb-5 md:mb-6 last:mb-0 text-textDselected text-xs md:text-base'>Series</span>
              <span className='flex items-center mb-5 md:mb-6 last:mb-0 text-textDselected text-xs md:text-base'>Date & Time</span>
              <span className='flex items-center mb-5 md:mb-6 last:mb-0 text-textDselected text-xs md:text-base'>Location</span>
            </div>
            <div className='col-span-9 md:border-r border-borderStroke'>
              <span className='flex items-center mb-5 md:mb-6 last:mb-0 text-textOffWhite text-xs md:text-base font-medium'>
                {data?.oMatch?.oSeries?.sTitle}
              </span>
              <span className='flex items-center mb-5 md:mb-6 last:mb-0 text-textOffWhite text-xs md:text-base font-medium'>
                {convertDate(data?.oMatch?.dStartDate)}
              </span>
              <span className='flex items-center mb-5 md:mb-6 last:mb-0 text-[#84AFDC] text-xs md:text-base font-medium'>
                {data?.oMatch?.oVenue?.sName}
              </span>
            </div>
          </div>
        </div>
        <div className='col-span-12 lg:col-span-4 flex pt-4 md:pt-0 flex-col w-full md:items-center items-start md:justify-center gap-2 justify-start'>
          <>
            <h5 className={`${scoreData?.sStatusStr === 'scheduled' ? 'block' : 'hidden'}`}>Match Starts In</h5>
            <div
              className={`${
                scoreData?.sStatusStr === 'scheduled' ? 'block' : 'hidden'
              } bg-primary-500 rounded-lg p-2 text-white font-semibold`}
            >
              <Timer timer={useTimer(scoreData?.sStatusStr === 'scheduled' ? scoreData?.dStartDate : null)?.timer} />
            </div>
            {scoreData?.sStatusStr === 'completed' && (
              <>
                <h5 className='text-primary-500 dark:text-ScheduledBG text-xs md:text-base flex items-center gap-1'>
                  <VerifyIcon />
                  Completed Match
                </h5>
                <h5 className='text-[#84AFDC] text-sm md:text-base flex items-center gap-1'>{scoreData?.sResult}</h5>
              </>
            )}
            {scoreData?.sStatusStr === 'live' && (
              <>
                <h5 className='text-red-500 flex items-center gap-1'>
                  <span className='h-2 w-2 rounded-full bg-red-500'></span>Live Match
                </h5>
                <h5 className='text-primary-500 flex items-center gap-1'>
                  {scoreData?.oLiveScore?.oTeam?.sAbbr} : {scoreData?.oLiveScore?.nRuns}/{scoreData?.oLiveScore?.nWickets} (
                  {`${scoreData?.oLiveScore?.sOvers}`})
                </h5>
              </>
            )}
          </>
        </div>
      </div>

      {/* status */}
      <div className='py-6 md:pt-8 md:pb-7 border-b border-borderStroke'>
        <div className='text-sm md:text-lg text-textOffWhite mb-4 font-bold'>Match Preview</div>
        <CommonContent>
          <div className='text-blackGray text-xs md:text-base pb-4 md:pb-6 fancy-detail'>
            <InnerHTML html={data?.sMatchPreview} />
          </div>
        </CommonContent>

        <div className='text-sm md:text-lg text-textOffWhite mb-4 font-bold pt-6 md:pt-4 border-t border-borderStroke'>Pitch Report</div>
        <div className='text-buttonText text-xs md:text-base fancy-detail'>{data?.oOverview?.sPitchReport}</div>
      </div>

      {/*Pitch Report*/}
      <div className='grid grid-cols-12 gap-4 py-6 md:py-8'>
        <div className='col-span-12 lg:col-span-6 gap-4 md:gap-5 flex items-center dark:border-0 border border-borderStroke bg-headersActive rounded-xl p-4 md:px-6 md:py-5'>
          <MyImage
            height={40}
            width={40}
            src={getImgURL(scoreData?.oWeatherInfo?.sUrl)}
            alt='weather'
            className='w-10 h-10 md:w-14 md:h-14'
          />
          <div className='flex flex-col'>
            <span className='text-buttonText mb-1 text-xxs md:text-base'>Weather reported</span>
            <span className='text-base md:text-2xl text-textOffWhite font-bold'>{data?.oOverview?.sWeatherReport}</span>
          </div>
        </div>
        <div className='col-span-12 lg:col-span-6 gap-4 md:gap-5 flex items-center dark:border-0 border border-borderStroke bg-headersActive rounded-xl p-4 md:px-6 md:py-5'>
          <MyImage
            src={scoreData?.oPitchInformation?.sUrl ? getImgURL(scoreData?.oPitchInformation?.sUrl) : PitchPlaceholder}
            height={60}
            width={60}
            alt='weather'
            className='w-10 h-10 md:w-14 md:h-14'
          />
          <div className='flex flex-col'>
            <span className='text-buttonText mb-1 text-xxs md:text-base'>Pitch Condition</span>
            <span className='text-base md:text-2xl text-textOffWhite font-bold'>{data?.oOverview?.sPitchCondition}</span>
          </div>
        </div>
        <div className='col-span-12 lg:col-span-6 gap-4 md:gap-5 flex items-center dark:border-0 border border-borderStroke bg-headersActive rounded-xl p-4 md:px-6 md:py-5'>
          <MyImage src={Cup} alt='weather' width={56} height={56} className='w-10 h-10 md:w-14 md:h-14' />
          <div className='flex flex-col'>
            <span className='text-buttonText mb-1 text-xxs md:text-base'>Predicted to win</span>
            <span className='text-base md:text-2xl text-textOffWhite font-bold'>{data?.oOverview?.oWinnerTeam?.sTitle}</span>
          </div>
        </div>
        <div className='col-span-12 lg:col-span-6 gap-4 md:gap-5 flex items-center dark:border-0 border border-borderStroke bg-headersActive rounded-xl p-4 md:px-6 md:py-5'>
          <MyImage src={Stadium} alt='weather' className='w-10 h-10 md:w-14 md:h-14' />
          <div className='flex flex-col'>
            <span className='text-buttonText mb-1 text-xxs md:text-base'>Avg. 1st inning score</span>
            <span className='text-base md:text-2xl text-textOffWhite font-bold'>{data?.oOverview?.sAvgScore}</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default MatchInfo
